import { LoginScreen } from '@/screens/auth/login-screen';
export default LoginScreen;
